module.exports = __webpack_public_path__ + "img/Logo_SVO.9ceb67f7.png";